module.exports = __webpack_public_path__ + "static/img/finger-key4.f29c76c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/remotekey/finger/finger-key4.jpg
// module id = g/vs
// module chunks = 0